import {Form} from "react-bootstrap"
import {useTranslation} from "react-i18next"
import {ExamAid, ExamAidCategory} from "../types"

type Props = {value: Partial<ExamAid>, onChange: (value: Partial<ExamAid>) => void}

const splitLines = (value: string): string[] => value.split("\n").map(line => line.trim()).filter(Boolean)

export default function ExamAidForm({value, onChange}: Props) {
    const {t} = useTranslation(["eexam"])

    return (
        <>
            <Form.Group className="mb-3">
                <Form.Label>{t("fields.titleDe")}</Form.Label>
                <Form.Control value={value.title?.de ?? ""} onChange={event => onChange({...value, title: {de: event.target.value, en: value.title?.en ?? ""}})}/>
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>{t("fields.titleEn")}</Form.Label>
                <Form.Control value={value.title?.en ?? ""} onChange={event => onChange({...value, title: {de: value.title?.de ?? "", en: event.target.value}})}/>
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>{t("fields.descriptionDe")}</Form.Label>
                <Form.Control as="textarea" rows={2} value={value.description?.de ?? ""} onChange={event => onChange({...value, description: {de: event.target.value, en: value.description?.en ?? ""}})}/>
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>{t("fields.descriptionEn")}</Form.Label>
                <Form.Control as="textarea" rows={2} value={value.description?.en ?? ""} onChange={event => onChange({...value, description: {de: value.description?.de ?? "", en: event.target.value}})}/>
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>{t("fields.category")}</Form.Label>
                <Form.Select value={value.category ?? "digital"} onChange={event => onChange({...value, category: event.target.value as ExamAidCategory})}>
                    <option value="digital">{t("categories.digital")}</option>
                    <option value="physical">{t("categories.physical")}</option>
                    <option value="hardware">{t("categories.hardware")}</option>
                </Form.Select>
            </Form.Group>
            <Form.Check className="mb-3" checked={Boolean(value.forceOpen)} onChange={event => onChange({...value, forceOpen: event.target.checked})} label={t("fields.forceOpen")}/>
            {value.category === "digital" && (
                <>
                    <Form.Group className="mb-3">
                        <Form.Label>{t("fields.publicUrlDe")}</Form.Label>
                        <Form.Control value={value.publicUrl?.de ?? ""} onChange={event => onChange({...value, publicUrl: {de: event.target.value, en: value.publicUrl?.en ?? ""}})}/>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>{t("fields.publicUrlEn")}</Form.Label>
                        <Form.Control value={value.publicUrl?.en ?? ""} onChange={event => onChange({...value, publicUrl: {de: value.publicUrl?.de ?? "", en: event.target.value}})}/>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>{t("fields.targetUrl")}</Form.Label>
                        <Form.Control value={value.targetUrl ?? ""} onChange={event => onChange({...value, targetUrl: event.target.value})}/>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>{t("fields.urlWhitelist")}</Form.Label>
                        <Form.Control as="textarea" rows={3} value={(value.urlWhitelist ?? []).join("\n")} onChange={event => onChange({...value, urlWhitelist: splitLines(event.target.value)})}/>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>{t("fields.urlBlacklist")}</Form.Label>
                        <Form.Control as="textarea" rows={3} value={(value.urlBlacklist ?? []).join("\n")} onChange={event => onChange({...value, urlBlacklist: splitLines(event.target.value)})}/>
                    </Form.Group>
                </>
            )}
        </>
    )
}
